export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/clientTypes/state.js